module.exports = "<html>\n<style>\n  body {\n    background: rgba(203, 229, 255, 0.1);\n  }\n</style>\n\n<body>\n  <div class=\"container\">\n    <div>\n      <h2 class=\"text-center\">FAQ</h2>\n    </div>\n    <div *ngFor=\"let faq of FAQList\">\n      <div class=\"term-header\">\n        <div *ngIf='FAQList !== null'>\n          <h4> {{faq.question}}</h4>\n          <div [innerHTML]=\"faq.answer\"></div>         \n        </div>\n      </div>\n    </div>\n  </div>\n</body>\n\n</html>"


//////////////////
// WEBPACK FOOTER
// ./src/app/user-faq/user-faq.component.html
// module id = ./src/app/user-faq/user-faq.component.html
// module chunks = main